/* ============
 * Client Group Transformer
 * ============
 *
 * The transformer for the client group.
 */

import Transformer from './transformer';

export default class ClientGroupTransformer extends Transformer {

  static fetch(clientGroup) {
    return {
      id: clientGroup.id,
      name: clientGroup.name,
      description: clientGroup.description,
      clientsCount: clientGroup.clients_count,
      priceFieldId: clientGroup.price_field_id,
      receivables_account_id: clientGroup.receivables_account_id,
    };
  }

  static send(clientGroup) {
    return {
      id: clientGroup.id,
      name: clientGroup.name,
      description: clientGroup.description,
      price_field_id: clientGroup.priceFieldId,
      receivables_account_id: clientGroup.receivables_account_id,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/clientGroup.js